import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

/**
 * Load Neue Haas Grotesk from Adobe Fonts / Typekit.
 * Set VITE_ADOBE_FONTS_KIT_ID in client/.env (kit id from fonts.adobe.com web project).
 */
const adobeFontsKitId = import.meta.env.VITE_ADOBE_FONTS_KIT_ID as string | undefined
if (adobeFontsKitId?.trim()) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `https://use.typekit.net/${adobeFontsKitId.trim()}.css`
  document.head.appendChild(link)
}

createRoot(document.getElementById("root")!).render(<App />);
